













































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { VersionService } from '@/services/VersionService';
import { Global } from '@/store';

@Component({})
export default class VersionUpdateDialog extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: String, required: true }) newVersion!: string;
  @Prop({ type: Boolean, default: false }) isProduction!: boolean;

  @Global.State('timezone') timezone!: string;
  @Global.State('lang') lang!: string;

  dialog = false;
  isRefreshing = false;

  @Watch('value')
  onValueChanged(val: boolean) {
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    this.$emit('input', val);
  }

  getVersionDisplay() {
    return VersionService.getVersionDisplay(this.newVersion, this.timezone);
  }

  async refreshApplication() {
    this.isRefreshing = true;
    try {
      await VersionService.refreshApplication();
    } catch (error) {
      console.error('Failed to refresh application:', error);
      // Fallback to simple reload
      window.location.reload();
    }
  }

  dismissDialog() {
    this.dialog = false;
    this.$emit('dismissed');
  }
}
